export default "__VITE_ASSET__BYSMuBnD__"